import { useTranslation } from 'react-i18next';
import useErrorStore, { setErrorActionSelector } from 'Core/stores/error';
import { useQuery } from 'react-query';
import cacheKeys from 'Core/hooks/queries/cacheKeys';
import { get } from 'Core/utils/api';
import { useNavigate } from 'react-location';
import { errorPath } from 'Core/routes';

export function useGetPaymentOptions() {
  const { t } = useTranslation();
  const setError = useErrorStore(setErrorActionSelector);
  const navigate = useNavigate();

  return useQuery(cacheKeys.directSalesPaymentOptions, () => get('/api/pay-options'), {
    onError(e) {
      if (e) {
        setError(t('status.error.getPaymentOptionsQueryFailed') + e.message);
        navigate({ to: errorPath, search: true });
      }
    },
  });
}
